module.exports = __webpack_public_path__ + "static/img/2.57490897.png";